// extracted by mini-css-extract-plugin
module.exports = {"FirstStep":"FirstStep-module__FirstStep___2DCOZ","icon":"FirstStep-module__icon___2Hi4Q","header":"FirstStep-module__header___MjJdP"};